import apiClient from './client';

export const getApiStatus = async () => {
  const response = await apiClient.get('/status/');
  return response.data;
};

export const getSiteSettings = async () => {
  const response = await apiClient.get('/site/');
  return response.data;
};

export const getCategories = async () => {
  const response = await apiClient.get('/categories/');
  return response.data;
};

export const getMenuItems = async () => {
  const response = await apiClient.get('/items/');
  return response.data;
};
